// pages/HomePage.jsx
import React, { useEffect } from "react";
import { useAuth } from "../../src/context/AuthContext";
import { useNavigate } from "react-router-dom";

const HomePage = ({ portalSettings }) => {
    const { user, loading: authLoading } = useAuth();
    const navigate = useNavigate();

    // If loading auth or no portal settings yet, just render nothing
    if (!portalSettings) return null;

    const psm = portalSettings || {};

    useEffect(() => {

        if (!user?.userID) return;
        if (!user) {
            navigate("/login", { replace: true });
            return;
        }

        if (user.role === "1") {
            navigate("/Admin", { replace: true });
            return;
        }

        //redirect based on role
        if (user.role === "2") {
            if (psm.hasPolicyPortal || psm.hasAgentPortal) {
                navigate("/Admin", { replace: true });
                return;
            }
            else if (psm.hasUWPortal) {
                navigate("/underwriting", { replace: true });
                return;
            }
            else if (psm.hasImagePortal) {
                navigate("/Images", { replace: true });
                return;
            } else {
                navigate("/Admin", { replace: true });
                return;
            }
        } else if (user.role == "3") {
            navigate(`/agent/${user.agentCode}`, { replace: true });
            return;
        }
        else if (user.role == "6") {
            navigate(`/termAgent/${user.agentCode}`, { replace: true });
            return;
        }
        else {
            navigate("/policies", { replace: true });
            return;
        }
    }, [user?.userID, authLoading]);

    return <div>Redirecting...</div>;
};

export default HomePage;

